import useGetMyAccountPipelines from '@/api/queries/me/useGetMyAccountPipelines';
import { ProjectsContext } from '@/ui/components/contextProviders/ProjectsContextProvider';
import { ButtonRadioGroup } from '@payaca/ambrosia';

import { ListedDealViews } from '@payaca/types/listedDealTypes';
import UntitledIcon from '@payaca/untitled-icons';
import { FC, useContext } from 'react';
import { useHistory } from 'react-router-dom';

const PipelineDisplayType: FC = () => {
  const projectsContext = useContext(ProjectsContext);
  const history = useHistory();
  const { data: pipelines } = useGetMyAccountPipelines();

  return (
    <ButtonRadioGroup
      value={projectsContext.displayType}
      onChange={(displayType) => {
        if (displayType !== projectsContext.displayType) {
          const firstPipelineId =
            pipelines && pipelines.length > 0 ? +pipelines[0].id : undefined;
          const pipelineId =
            projectsContext.requestData.pipelineId ??
            (displayType === ListedDealViews.PIPELINE
              ? firstPipelineId
              : undefined);
          projectsContext.onUpdate({ displayType, pipelineId });
          history.push('/deals');
        }
      }}
      options={[
        { label: 'Pipeline', value: ListedDealViews.PIPELINE },
        { label: 'Table', value: ListedDealViews.TABLE },
      ]}
      sizeVariant={'sm'}
      CustomOption={({ option }) => {
        return (
          <UntitledIcon
            className="size-6"
            name={
              option.value == ListedDealViews.PIPELINE ? 'columns-02' : 'list'
            }
          />
        );
      }}
    />
  );
};

export default PipelineDisplayType;
